<template>
  <div class="row">
    <div class="col-md-6">
      <b-card :header="displayName">
        <img :src="detailedInfo.avatar" alt="Profile Picture">
        <br>
        {{displayName}}
        <span slot="footer">Go to <!-- <router-link class="font-weight-bold" :to="'/users/' + detailedInfo.id"> -->profile<!-- </router-link> --> page</span>
      </b-card>
      <card-list-info header="Account" :items="accountInfo"></card-list-info>
      <card-list-info header="Address" :items="addressInfo"></card-list-info>
    </div>
    <div class="col-md-6">
      <b-card v-if="amISystemAdmin && amISuperior(detailedInfo)" header="Transfer user">
        <label>Company</label>
        <multiselect
            v-model="selectedCompany"
            :options="companies"
            label="name"
            track-by="id"
            placeholder="Select company" class="mb-4"/>
        <b-button variant="primary">Transfer</b-button>
      </b-card>
      <b-card v-if="amISuperior(detailedInfo)" header-bg-variant="warning" border-variant="warning" header="Disable this user">
        <p>Blocking users has the following effects: </p>
        <ul class="pl-4">
          <li>User will not be able to login</li>
          <li>Personal token access will be revoked</li>
          <li>Email Report schedule will be stopped</li>
        </ul>
        <b-button variant="warning">Disable</b-button>
      </b-card>
      <b-card v-if="amISuperior(detailedInfo)" header-bg-variant="danger" border-variant="danger" header="Remove this user">
        <p>Removing users has the following effects: </p>
        <ul class="pl-4">
          <li>Custom Reports made by user will be removed</li>
          <li>Email Report schedule will be removed</li>
          <li>User data will not be retrievable</li>
        </ul>
        <b-button v-b-modal.delete_user variant="danger">Remove</b-button>
      </b-card>
    </div>
    <div>
      <b-modal
        id="delete_user"
        title="Delete User"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="deleteUser()">
        <p class="my-4">Are you sure want to delete this user ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import userMixin from '@/mixins/user';
import { isEmpty } from 'lodash';
import CardListInfo from '@/components/CardListInfo';
import Multiselect from 'vue-multiselect';

export default {
  mixins: [dateMixin, userMixin],
  components: {
    CardListInfo,
    Multiselect,
  },
  data() {
    return {
      selectedCompany: null,
    };
  },
  created() {
    this.$store.dispatch('users/LOAD_DETAIL_DATA');
    if (this.amISystemAdmin) {
      this.$store.commit('companies/CLEAR_QUERY');
      this.$store.dispatch('companies/LOAD_INFO').then(() => {
        this.$store.commit('companies/SET_QUERY_COUNT', this.company_count_all);
        this.$store.dispatch('companies/LOAD_DATA');
      });
    }
  },
  computed: {
    companies() {
      return this.$store.getters['companies/companies'];
    },
    displayName() {
      return this.detailedInfo.full_name;
    },
    detailedInfo() {
      return this.$store.getters['users/get_detail_data'];
    },
    detailLoaded() {
      return this.$store.getters['users/detailLoaded'];
    },
    company_count_all() {
      return this.$store.getters['companies/count_all'];
    },
    accountInfo() {
      const info = this.detailedInfo;
      const { vehicle } = info;

      const infoList = [
        { key: 'name', label: 'Name', value: info.full_name },
        { key: 'username', label: 'User name', value: info.username },
        // {key: 'phone', label: 'Phone Number', value: info.phone},
        // {key: 'mobile', label: 'Mobile Number', value: info.mobile}
      ];

      if (isEmpty(vehicle)) {
        infoList.push({
          key: 'email',
          label: 'Email',
          value: info.email,
        });
      }

      infoList.push({
        key: 'created_at',
        label: 'Member since',
        value: this.formatDateDistance(info.created_at),
        title: this.formatDateTime(info.created_at),
      });

      return infoList;
    },
    addressInfo() {
      let { address } = this.detailedInfo;
      address = address || {};

      const infoList = [
        { key: 'country', label: 'Country', value: address.country },
        { key: 'state', label: 'State', value: address.state },
        { key: 'city', label: 'City', value: address.city },
        { key: 'address1', label: 'Address 1', value: address.address1 },
        { key: 'address2', label: 'Address 2', value: address.address2 },
        { key: 'zip_code', label: 'Zip Code', value: address.zip_code },
        // { key: 'latitude', label: 'latitude', value: address.latitude },
        // { key: 'longitude', label: 'longitude', value: address.longitude },
      ];

      return infoList;
    },
    userType() {
      const { type } = this.detailedInfo;
      switch (type) {
        case 'SYSTEM_ADMIN':
          return 'System Admin';
        case 'ADMIN':
          return 'Admin';
        default:
          return 'User';
      }
    },
    isAdmin() {
      return this.detailedInfo.type === 'ADMIN' ||
        this.detailedInfo.type === 'SYSTEM_ADMIN';
    },
  },
  watch: {
    detailedInfo(data) {
      this.selectedCompany = data.company;
    },
    detailLoaded(loaded) {
      if (loaded && isEmpty(this.detailedInfo)) {
        // TODO: Find out how can we replace this with 404
        this.$router.push('/admin/users');
      }
    },
  },
  methods: {
    deleteUser() {
      this.$store.dispatch('users/DELETE_DATA').then((ok) => {
        if (ok) this.$router.push('/admin/users');
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/users/detail/Preview.vue